// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fb334237","488":"81c9c5ef","952":"21847e00","977":"dd2563ec"}[chunkId] + ".chunk.js";
};